import axios from '../../axios'
import {GET_REWARD_LIST,GET_REWARD_HISTORY_LIST,ADD_REWARD,UPDATE_REWARD,DELETE_REWARD, EXPORT_REWARD_HISTORY} from './rewardListTypes'

import {URL_GET_REWARD_LIST,URL_GET_REWARD_HISTORY_LIST,URL_ADD_REWARD,URL_UPDATE_REWARD,URL_DELETE_REWARD, URL_EXPORT_REWARD_HISTORY} from './rewardListUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'

export default {
  [GET_REWARD_LIST] ({commit},item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REWARD_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REWARD_LIST, data);
              resolve(data);
            } else {
              commit(GET_REWARD_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_REWARD_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [GET_REWARD_HISTORY_LIST] ({commit},item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REWARD_HISTORY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REWARD_HISTORY_LIST, data);
              resolve(data);
            } else {
              commit(GET_REWARD_HISTORY_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_REWARD_HISTORY_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
          // if(response.data.result !== null) {
          //   commit(GET_REWARD_HISTORY_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },
  [ADD_REWARD] ({dispatch},item) {
    var bodyFormData = new FormData();
    for(var key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_REWARD}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page : item.page,
                "per-page" : item['per-page'],
                search : item.search
              }
              dispatch(GET_REWARD_LIST, temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // let temp = {
          //   page : item.page,
          //   "per-page" : item.perpage,
          //   search : item.search
          // }
          // dispatch("GET_REWARD_LIST", temp)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_REWARD] ({dispatch},item) {
    let param = new URLSearchParams(item).toString();
    var bodyFormData = new FormData();
    for(var key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_REWARD}${param}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page : item.page,
                "per-page" : item['per-page'],
                search : item.search
              }
              dispatch(GET_REWARD_LIST, temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // let temp = {
          //   page: item.page,
          //   "per-page" : item.perpage,
          //   search : item.search
          // }
          // dispatch("GET_REWARD_LIST", temp)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [DELETE_REWARD] ({dispatch},item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_REWARD}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              delete item.id
              dispatch(GET_REWARD_LIST, item)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // delete item.id
          // dispatch("GET_REWARD_LIST" , item)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [EXPORT_REWARD_HISTORY] ({commit},item) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_REWARD_HISTORY}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error);reject(error) })
    })
  },
}
